<template>
    <div class="form-group">
      <p class="h6">
        <span>{{ property.question }}</span>
        <span class="ml-1" v-if="property.hint">
          <b-icon-question-circle-fill class="question-hint" v-if="property.hint" :id="`popover-target-${property.id}`"></b-icon-question-circle-fill>
      </span>
      </p>
      <b-popover v-if="property.hint" :target="`popover-target-${property.id}`" triggers="hover" placement="top">
        {{ property.hint}}
      </b-popover>
        <div>
            <component v-bind:is="answerType" 
                :answer="property.answer" 
                :questionId="property.id" 
                :isReadOnly="isReadOnly"/>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from "vue-property-decorator";
    import {Property} from "@/entities/questionaire/Property";
    import AppBooleanAnswer from "@/components/questionnaire/answer-types/AppBooleanAnswer.vue";
    import AppIntegerAnswer from "@/components/questionnaire/answer-types/AppIntegerAnswer.vue";
    import AppSingleItemAnswer from "@/components/questionnaire/answer-types/AppSingleItemAnswer.vue";
    import AppMultipleItemsAnswer from "@/components/questionnaire/answer-types/AppMultipleItemsAnswer.vue";

    @Component({
        components: {
            AppBooleanAnswer,
            AppIntegerAnswer,
            AppSingleItemAnswer,
            AppMultipleItemsAnswer
        }
    })
    export default class AppProperty extends Vue {
        private answerType!: string;

        @Prop()
        property!: Property;

        @Prop()
        isReadOnly!: boolean;

        created(): void {
            this.answerType = this.property.answer.getComponentName();
        }
    }
</script>

<style scoped>

.question-hint{
  position: relative;
  top: -5px;
  cursor: pointer;
}
</style>
